<mat-sidenav-container class="sidenav-container" fxLayout="column">
  <mat-sidenav
    color="primary"
    #sidenav
    mode="over"
    class="sidenav"
    [ngClass.sm]="{ small: true }"
    fixedInViewport="true"
    [attr.role]="
      (isHandset$ | async) || (isTablet$ | async) ? 'dialog' : 'navigation'
    "
    [opened]="showSideNav$ | async"
    (closed)="closeSideNav()"
  >
    <mat-toolbar
      color="primary"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="1em"
    >
      <button
        type="button"
        id="sidenavbutton"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="closeSideNav()"
      >
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
    </mat-toolbar>
    <mat-nav-list
      id="SideNavList"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <mat-list-item
        routerLinkActive="link-active"
        [routerLinkActiveOptions]="{ exact: true }"
        *ngIf="identity.userLoggedIn$ | async"
      >
        <mat-icon matListIcon>search</mat-icon>
        <a matLine routerLink="available-services"> Find Services </a>
        <mat-divider></mat-divider>
      </mat-list-item>
      <mat-list-item *ngIf="identity.userLoggedIn$ | async">
        <mat-icon matListIcon>stars</mat-icon>
        <a matLine> Recommendations </a>
      </mat-list-item>
      <mat-list-item
        routerLinkActive="link-active"
        [routerLinkActiveOptions]="{ exact: true }"
        *ngIf="identity.userLoggedIn$ | async"
      >
        <mat-icon matListIcon>message</mat-icon>
        <a matLine routerLink="my-contacts"> My Contacts </a>
        <mat-divider></mat-divider>
      </mat-list-item>
      <mat-list-item
        routerLinkActive="link-active"
        [routerLinkActiveOptions]="{ exact: true }"
        *ngIf="
          (identity.userIsServiceProvider$ | async) &&
          (identity.userLoggedIn$ | async)
        "
      >
        <mat-icon matListIcon>edit</mat-icon>
        <a matLine routerLink="my-services"> My Services </a>
      </mat-list-item>
      <mat-list-item
        routerLinkActive="link-active"
        [routerLinkActiveOptions]="{ exact: true }"
        *ngIf="
          (identity.userIsServiceProvider$ | async) &&
          (identity.userLoggedIn$ | async)
        "
      >
        <mat-icon matListIcon>message</mat-icon>
        <a matLine routerLink="my-service-contacts"> My Service Contacts</a>
        <mat-divider></mat-divider>
      </mat-list-item>
      <mat-list-item
        routerLinkActive="link-active"
        [routerLinkActiveOptions]="{ exact: true }"
        *ngIf="identity.userLoggedIn$ | async"
      >
        <mat-icon matListIcon>account_circle</mat-icon>
        <a matLine routerLink="my-profile"> My Profile </a>
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content
    class="sidenav-container"
    fxLayout="column"
    fxLayoutAlign="start center"
    [ngClass.gt-xs]="{ 'secondary-background': true }"
  >
    <div class="output-container">
      <router-outlet (activate)="onActivate()"></router-outlet>
      <app-loading-spinner [(show)]="routeLoading"
        >Getting things ready...</app-loading-spinner
      >
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
